"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10.424 14.253a.5.5 0 0 0 .707-.707 2.5 2.5 0 0 1 0-3.536l3.182-3.182a2 2 0 1 1 2.829 2.829l-2.475 2.475a.5.5 0 1 0 .707.707l2.475-2.475a3 3 0 1 0-4.243-4.243l-3.182 3.182a3.5 3.5 0 0 0 0 4.95"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.546 10.718a.5.5 0 0 0-.708.707 2.5 2.5 0 0 1 0 3.535l-3.182 3.182a2 2 0 0 1-2.828-2.828l2.475-2.475a.5.5 0 1 0-.707-.707L5.12 14.607a3 3 0 0 0 4.243 4.242l3.181-3.182a3.5 3.5 0 0 0 0-4.95"
  })]
}), 'CopyLink');
